import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  progressBar: {
    marginTop: 16
  }
})

export default useStyles
